export default "__VITE_PUBLIC_ASSET__639ae05c__"